import { useBoolean } from '@qfa/react-components';
import { StatusBarPreference } from 'components/StatusBarWrapper';
import { useCallback, useMemo } from 'react';
import { useUserTenantPreference } from 'kineticUtils/hooks';
import { PREFERENCE_KEYS } from 'types/preferenceTypes';

export const useStatusBarState = () => {
  const { value: preference, setPreference } = useUserTenantPreference<StatusBarPreference>({
    key: PREFERENCE_KEYS.MAP_STATUS_BAR,
  });

  const [{ toggle }, isStatusBarOpen] = useBoolean(preference?.isStatusBarOpen || false);

  const toggleStatusBar = useCallback(() => {
    setPreference({
      activeStatusBar: preference.activeStatusBar,
      isStatusBarOpen: !isStatusBarOpen,
    });
    toggle();
  }, [isStatusBarOpen, preference.activeStatusBar, setPreference, toggle]);

  const contextValue = useMemo(
    () => ({
      toggleStatusBar,
      isStatusBarOpen,
    }),
    [isStatusBarOpen, toggleStatusBar]
  );

  return contextValue;
};
